import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import CheckInCheckOut from '../CheckInCheckOut';

import HotelPolicyList from './HotelPolicyList';

import type { I18nService } from '@shared/types/i18n';

import STYLES from './GoodToKnow.module.scss';

import { useHotelPolicies } from '@hotels-hotel-detail/data-access/hooks/useHotelContent';
import ExpandableSection from '@hotels-hotel-detail/ui/ExpandableSection';
import { HASH_GOOD_TO_KNOW } from '@shared/constants/hash-routes';
import BpkBreakpoint, { BREAKPOINTS } from '@shared/ui/common/BpkBreakpoint';
import { withI18n } from '@shared/ui/contexts/i18n';

type Props = {
  i18n: I18nService;
};

const cls = cssModules(STYLES);

const GoodToKnow = ({ i18n }: Props) => {
  const hotelPolicies = useHotelPolicies();

  if (!hotelPolicies?.length) {
    return <CheckInCheckOut />;
  }

  return (
    <>
      <CheckInCheckOut />
      <BpkBreakpoint query={BREAKPOINTS.MOBILE}>
        {(isMobile: boolean) =>
          isMobile ? (
            <ExpandableSection
              href={HASH_GOOD_TO_KNOW}
              headline={i18n.translate('Sidebar_goodToKnow')}
              headerClassName={cls('GoodToKnow__header')}
              viewportMoreContent={
                <HotelPolicyList policyList={hotelPolicies} inModal />
              }
              showActionLink={hotelPolicies.length > 2}
            >
              <HotelPolicyList policyList={hotelPolicies.slice(0, 2)} />
            </ExpandableSection>
          ) : (
            <HotelPolicyList policyList={hotelPolicies} />
          )
        }
      </BpkBreakpoint>
    </>
  );
};

export default withI18n(GoodToKnow);
